export function formatGBP(amount) {
  return new Intl.NumberFormat("en-GB", { style: "currency", currency: "GBP" }).format(amount);
}

export function formatCurrency(amount, currency) {
  return new Intl.NumberFormat("en-GB", { style: "currency", currency }).format(amount);
}

export function formatTimestamp(iso) {
  return new Date(iso).toLocaleString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function formatDateRange(start, end) {
  const startLabel = start.toLocaleDateString("en-GB", { day: "numeric", month: "short" });
  const endLabel = end.toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" });
  return `${startLabel} \u2013 ${endLabel}`;
}
/**
 * A Date as the YYYY-MM-DD the API and the CSV filenames both speak.
 *
 * Note this is the UTC day, which is what `toISOString` gives: the range
 * pickers build their dates at UTC midnight, so the two agree. Formatting a
 * local-midnight date here would shift it a day behind through BST.
 */
export function isoDay(date) {
  return date.toISOString().slice(0, 10);
}
